export default () => {
  const data = {
    event_name: 'click',
    button_name: 'property_details',
    page_section: 'card_section',
    name_of_the_page_viewed: 'development_list_personal',
  };
  return data;
};
